/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/403-instagram': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM11 2.5c0-.275.225-.5.5-.5h2c.275 0 .5.225.5.5v2c0 .275-.225.5-.5.5h-2a.501.501 0 01-.5-.5v-2zM8 5a3.001 3.001 0 010 6 3.001 3.001 0 010-6zm6 8.5c0 .275-.225.5-.5.5h-11a.501.501 0 01-.5-.5V7h1.1A4.999 4.999 0 008 13a4.999 4.999 0 004.9-6H14v6.5z"/>'
  }
})
